import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postInitiateOfferingTransactionFundsMovement } from '@arrived/api_v2';
import { OfferingTransaction, OfferingTransactionId } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { accountTradesQueryKeyFn, tradeQueryKeyFn, userTradesQueryKeyFn } from './trades.keys';

export function usePostInitiateTradeFundsMovementMutation(
  options?: UseMutationOptions<OfferingTransaction, OfferingTransactionId>
) {
  const queryClient = useQueryClient();

  return useMutation((tradeId) => postInitiateOfferingTransactionFundsMovement(tradeId), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { id: tradeId, accountId, userId } = data;

      queryClient.setQueryData(tradeQueryKeyFn(tradeId), data);

      queryClient.invalidateQueries(tradeQueryKeyFn(tradeId));
      queryClient.invalidateQueries(accountTradesQueryKeyFn(accountId));
      queryClient.invalidateQueries(userTradesQueryKeyFn(userId));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
